import { FormSchema, validateFormSchema } from "@leadpro/forms";

import { FieldError, ResolverResult } from "react-hook-form";
import { FieldErrors } from "react-hook-form/dist/types/errors";

export function validateFormFieldsFromSchemaExcludingLogic<Values>(
  schema: FormSchema,
  values: Values
): ResolverResult<Values> {
  const { errors } = validateFormSchema({
    ...schema,
    logic: undefined,
  });
  if (!errors)
    return {
      values,
      errors: {},
    };

  const result: FieldErrors<Values> = {};
  errors.forEach(error => {
    const fieldKey = error.path[error.path.length - 1] as keyof Values;
    const isRootError = error.path.length === 1;
    result[fieldKey] = {
      message: error.message.replace(error.path.join("."), fieldKey.toString()),
      ref: { name: fieldKey.toString() },
    } as any;

    if (isRootError) {
      result[fieldKey] = {
        message: error.message.replace(
          error.path.join("."),
          fieldKey.toString()
        ),
        type: "global",
      } as any;
    }
  });

  return {
    values: {},
    errors: result,
  };
}

export const extractGlobalErrorMessagesFromValidationErrors = (
  errors: FieldErrors
): string[] => {
  const messages: string[] = [];

  for (const key of Object.keys(errors)) {
    const error = errors[key] as FieldError | undefined;
    if (!error) continue;

    if (error.type === "global" && !!error.message) {
      messages.push(error.message);
    }
  }

  return messages;
};
